// extracted by mini-css-extract-plugin
export default {"loaderHolder":"Loader_loaderHolder__bPsrx","customLoader":"Loader_customLoader__nbvVz","s8":"Loader_s8__aM8e+"};